import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  buildLacTenantStatsSearchParams,
  parseKnowledgeBaseIdFromSearchParams,
} from '../lacTenantStatsSearchParams';

export function useLacTenantStatsSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const knowledgeBaseId = useMemo(
    () => parseKnowledgeBaseIdFromSearchParams(searchParams),
    [searchParams],
  );

  const setKnowledgeBaseId = useCallback(
    (nextKnowledgeBaseId: string | null) => {
      setSearchParams(buildLacTenantStatsSearchParams(nextKnowledgeBaseId), {
        replace: true,
      });
    },
    [setSearchParams],
  );

  return {
    knowledgeBaseId,
    setKnowledgeBaseId,
  };
}
